import { render, staticRenderFns } from "./QuestionComment.vue?vue&type=template&id=23028380&"
import script from "./QuestionComment.vue?vue&type=script&lang=ts&"
export * from "./QuestionComment.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionComment.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports